/**
 * 安装方式分类统计组件
 * zxw
 * 2025-05-31
 */
import React, { useEffect, useState } from 'react';
import {
    message,
    Row,
    Col,
    Select,
} from 'antd';
import $ from 'jquery';
import { Chart } from '@antv/g2';
import {
    UjoinParams,
    AddRequestHeaders,
    winWidth,
    isGTscreenWidth,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const Option = Select.Option;

const PointLocationInfoDCIM = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [collectLists, setCollectLists] = useState([]);
    const [collectULID, setCollectULID] = useState('');
    const [data, setData] = useState([]);

    useEffect(() => {
        /**
         * 获取点位采集下拉列表
         * props.data为真，则是通过Chat调用数据
         */
        if (!props.data && !collectLists.length) {
            $.ajax({
                url: `${CNF.api}pointLocation/collects?rss=list`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setCollectLists(data.dat);
                            setCollectULID(data.dat[0].key);
                            setIsRefresh(true);//  刷新数据
                        }
                    } else {
                        message.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }
    }, [props.data, collectLists.length])

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh && collectULID) {
                //  获取数据
                const params = {
                    'mod': 'DCIM',
                    'collect_ulid': collectULID,
                }
                $.ajax({
                    url: `${CNF.api}report/pointLocationInfo${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON'
                }).done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setData(data.dat);
                        } else {
                            setData([]);
                        }
                        setIsRefresh(false);
                    } else {
                        message.error(data.msg, CNF.messageDuration);
                    }
                }).fail(function (data) {
                    message.error(data.responseJSON.detail, CNF.messageDuration);
                })
            }
        }
    }, [props, isRefresh, data, collectULID]);

    useEffect(() => {
        const chart = new Chart({
            width: winWidth - (props.collapsed ? 80 : 200) - 50,
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '安装方式分类占比',
            subtitle: '展示各种安装方式占比，使用百分比。',
        });

        chart.data(data);
        chart.coordinate({ type: 'theta', outerRadius: 0.8 });
        chart
            .interval()
            .transform({ type: 'stackY' })
            .encode('y', 'percent')
            .encode('color', 'type')
            .legend('color', { position: 'top', layout: { justifyContent: 'left' } })
            .animate('enter', {
                type: 'waveIn',
                duration: 1000,
            })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .label({
                position: 'spider',
                text: (data) => `${data.type}: ${data.percent.toFixed(CNF.DPL)}%`,
            })
            .style('radius', 4)
            .style('stroke', '#fff')
            .style('lineWidth', 2)
            .label({
                text: 'count',
                fontWeight: 'bold',
            })
            .tooltip((data) => ({
                name: data.type,
                value: `${data.percent.toFixed(CNF.DPL)}%`,
            }))
            .tooltip((data) => ({
                name: '数量',
                value: `${data.count}个`,
            }));
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <>
        <Row style={{ height: 60, paddingTop: 10, paddingLeft: 20 }}>
            <Col span={isGTscreenWidth ? 4 : 5}>
                <Select
                    showSearch
                    value={collectULID}
                    style={{ width: '100%' }}
                    onChange={(value) => setCollectULID(value)}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                >
                    {
                        collectLists && collectLists.map((item) => {
                            return <Option key={item.key} value={item.key}>{item.name}</Option>
                        })
                    }
                </Select>
            </Col>
        </Row>
        <div id='antv-g2-id' style={{ padding: '0px 8px', }}></div>
    </>

}

export default PointLocationInfoDCIM;